module.exports = __webpack_public_path__ + "static/media/youtube.4d17c0b8.svg";